import messages from "messages";
import moment from "moment-timezone";

export const DATE_FORMAT = "MMM DD yyyy";
/**
 * Format schedule title
 * format1: start - end
 * format2: start -
 * @param value schedule
 * @param timezone timezone
 */
export default function formatScheduleTitle(
  value: Pick<ParsedAvailableTimePeriod, "start_date" | "end_date">,
  timezone: TimeZone,
) {
  if (!value.start_date && !value.end_date) {
    return messages.newSchedule;
  }
  const start = moment(value.start_date).tz(timezone).format(DATE_FORMAT);
  const end = !value.end_date
    ? messages.noEndDate
    : moment(value.end_date).tz(timezone).format(DATE_FORMAT);
  return [start, end].join(" - ");
}
